import "../sass/main.scss"
// modules / classes

import mscsPrograms from "./modules/mscsPrograms"
import mscsCalls from "./modules/mscsCalls"
import mscsSummerSchools from "./modules/mscsSummerSchools"
// Instantiate a new object using our modules/classes
const Programs = new mscsPrograms()
const Calls = new mscsCalls()
const SummerSchools = new mscsSummerSchools()